/// <amd-module name="WorkItemsHub/Components/IWorkItemsTabContentData" />
export interface IWorkItemsTabContentData {
    /**
     * Tab ID.
     */
    tabId: string;
    /**
     * Work item IDs of items that are selected
     */
    selectionIds: number[];
    /**
     * Indicates if content has filter applied
     */
    hasFilter: boolean;
}
